"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionTypesContainer = void 0;
var _react = require("react");
var _components = require("../components");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _SubscriptionContainer = require("./SubscriptionContainer");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionTypesContainer = () => {
  const {
    wizardType,
    productCode,
    id,
    open
  } = (0, _react.useContext)(_contexts.wizardContext);
  (0, _logger.logDebug)('SubscriptionTypesContainer type: ', wizardType, ' | open: ', open, ' | product: ', productCode, ' | id: ', id);
  if (!wizardType) {
    (0, _logger.logDebug)('SubscriptionTypesContainer return null');
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.WizardLoader, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionContainer.SubscriptionContainer, {
      product: productCode
    }, id)
  });
};
exports.SubscriptionTypesContainer = SubscriptionTypesContainer;
